import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import DropzoneComponent from 'react-dropzone-component'
import 'react-dropzone-component/styles/filepicker.css'
import {
  UploadFileWrapper
} from './styled'

export class UploadFile extends React.PureComponent {
  render() {
    const {
      className,
      document,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'upload-file',
      { 'is-document': document },
      className
    )

    return (
      <UploadFileWrapper
        className={classes}
      >
        <DropzoneComponent
          {...this.props}
        />
      </UploadFileWrapper>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
